module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/axios/index.js
// module id = mtWM
// module chunks = 64